import axios from 'axios'
import { CHAT_ENDPOINTS } from '../config/chatEndpoints'

export const extractUserData = async (payload) => {
  const response = await axios.post(CHAT_ENDPOINTS.ExtractUserData, payload)

  return response.data
}
